import { render, staticRenderFns } from "./jkzDetail.vue?vue&type=template&id=24961072&scoped=true&"
import script from "./jkzDetail.vue?vue&type=script&lang=js&"
export * from "./jkzDetail.vue?vue&type=script&lang=js&"
import style0 from "./jkzDetail.vue?vue&type=style&index=0&id=24961072&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24961072",
  null
  
)

export default component.exports